import {
  YELLOW_GET_ARTICLES_REQUEST,
  YELLOW_GET_ARTICLES_SUCCESS,
  YELLOW_GET_ARTICLES_FAIL,
  YELLOW_GET_CATEGORIES_REQUEST,
  YELLOW_GET_CATEGORIES_SUCCESS,
  YELLOW_GET_CATEGORIES_FAIL,
  YELLOW_REMOVE_ARTICLE_REQUEST,
  YELLOW_REMOVE_ARTICLE_SUCCESS,
  YELLOW_REMOVE_ARTICLE_FAIL,
  YELLOW_GET_ARTICLE_REQUEST,
  YELLOW_GET_ARTICLE_SUCCESS,
  YELLOW_GET_ARTICLE_FAIL,
  YELLOW_EDIT_ARTICLE_REQUEST,
  YELLOW_EDIT_ARTICLE_SUCCESS,
  YELLOW_EDIT_ARTICLE_FAIL,
  YELLOW_CREATE_ARTICLE_REQUEST,
  YELLOW_CREATE_ARTICLE_SUCCESS,
  YELLOW_CREATE_ARTICLE_FAIL
} from "../actions/yellowpage";

const initialState = {
  getArticlesRequest: false,
  getArticleRequest: false,
  getAuthorsRequest: false,
  removeArticleRequest: false,
  getCategoriesRequest: false,
  categories: [],
  errorMsg: "",
  successMsg: "",
  errors: {},
  articles: [],
  authors: [],
  articlesPagination: {},
  selectedArticle: {},

  editArticleRequest: false,
  successBackMsg: "",
  selectedArticles: []
};

const yellowpage = (state = initialState, action) => {
  switch (action.type) {
    case YELLOW_GET_ARTICLES_REQUEST:
      return {
        ...state,
        getArticlesRequest: true,
          errorMsg: "",
          successMsg: "",
          successBackMsg: "",
          errors: {}
      };
    case YELLOW_GET_ARTICLES_SUCCESS:
      return {
        ...state,
        getArticlesRequest: false,
          errorMsg: "",
          successMsg: action.msg,
          errors: {},
          articles: action.data.data,
          articlesPagination: {
            currentPage: action.data.current_page,
            lastPage: action.data.last_page
          }
      };
    case YELLOW_GET_ARTICLES_FAIL:
      return {
        ...state,
        getArticlesRequest: false,
          errorMsg: action.msg,
          successMsg: "",
          errors: action.errors
      };
    case YELLOW_GET_CATEGORIES_REQUEST:
      return {
        ...state,
        getCategoriesRequest: true,
          errorMsg: "",
          successMsg: "",
          errors: {}
      };
    case YELLOW_GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        getCategoriesRequest: false,
          categories: action.data
      };
    case YELLOW_GET_CATEGORIES_FAIL:
      return {
        ...state,
        getCategoriesRequest: false,
          categories: null
      };
    case YELLOW_REMOVE_ARTICLE_REQUEST:
      return {
        ...state,
        removeUserRequest: true,
          errorMsg: "",
          successMsg: "",
          errors: {},
          selectedArticle: {}
      };
    case YELLOW_REMOVE_ARTICLE_SUCCESS:
      return {
        ...state,
        removeUserRequest: false,
          errorMsg: "",
          successMsg: action.msg,
          errors: {},
          selectedArticle: {}
      };
    case YELLOW_REMOVE_ARTICLE_FAIL:
      return {
        ...state,
        removeUserRequest: false,
          errorMsg: action.msg,
          successMsg: "",
          errors: action.errors,
          selectedArticle: {}
      };
    case YELLOW_GET_ARTICLE_REQUEST:
      return {
        ...state,
        getArticleRequest: true,
          successMsg: "",
          errorMsg: "",
          errors: {},
          selectedArticle: {}
      };
    case YELLOW_GET_ARTICLE_SUCCESS:
      return {
        ...state,
        getArticleRequest: false,
          successMsg: "",
          errorMsg: "",
          errors: {},
          selectedArticle: action.data
      };
    case YELLOW_GET_ARTICLE_FAIL:
      return {
        ...state,
        getArticleRequest: false,
          successMsg: "",
          errorMsg: action.msg,
          errors: action.errors,
          selectedArticle: {}
      };
    case YELLOW_EDIT_ARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
          successBackMsg: "",
          errorMsg: "",
          errors: {}
      };
    case YELLOW_EDIT_ARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: action.msg,
          errorMsg: "",
          errors: {}
      };
    case YELLOW_EDIT_ARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: "",
          errorMsg: action.msg,
          errors: action.errors
      };
    case YELLOW_CREATE_ARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
          successBackMsg: "",
          errorMsg: "",
          errors: {}
      };
    case YELLOW_CREATE_ARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: action.msg,
          errorMsg: "",
          errors: {}
      };
    case YELLOW_CREATE_ARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: "",
          errorMsg: action.msg,
          errors: action.errors
      };

    default:
      return state;
  }
};

export default yellowpage;